<template>
  <div>
    <v-card
      flat
      class="rounded-lg"
      :key="reRender"
      :class="!isEdit ? 'mouse-cursor' : ''"
    >
      <div class="pa-4 d-flex justify-center align-center">
        <div class="flex-column flex-grow-1">
          <div class="d-flex justify-center align-center">
            <v-img
              v-if="!isEdit"
              class="rounded-lg no-filter"
              :width="imgWidth"
              :height="imgHeight"
              :src="
                getImage(avatar) ||
                require('@/app/core-module/assets/images/logo_placeholder.png')
              "
              lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
              contain
            />

            <image-uploader
              v-else
              id="logo"
              :maxWidth="1024"
              :maxHeight="1024"
              :quality="1"
              :autoRotate="true"
              outputFormat="blob"
              :preview="false"
              :className="['fileinput', { 'fileinput--loaded': hasLogo }]"
              :capture="false"
              accept="image/*"
              doNotResize="['gif', 'svg']"
              @input="setLogo"
            >
              <label for="logo" slot="upload-label">
                <a>
                  <v-img
                    v-if="logoUrl"
                    class="image-custom-preview"
                    :src="logoUrl"
                    :width="imgWidth"
                    :height="imgHeight"
                    contain
                  />

                  <div v-if="!hasLogo" class="upload-caption gray1--text">
                    <v-img
                      v-if="avatar"
                      class="rounded-lg no-filter"
                      :width="imgWidth"
                      :height="imgHeight"
                      :src="
                        getImage(avatar) ||
                        require('@/app/core-module/assets/images/logo_placeholder.png')
                      "
                      lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
                      contain
                    />

                    <v-img
                      v-else
                      class="rounded-lg no-filter"
                      :width="imgWidth"
                      :height="imgHeight"
                      lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
                      contain
                    />
                  </div>
                </a>
              </label>
            </image-uploader>
          </div>

          <div class="d-flex justify-end">
            <float-btn
              v-if="isEditable"
              :isEdit="isEdit"
              @save="onClick"
              @edit="isEdit = true"
              :bottom="true"
              :loading="savingData"
              class="me-9"
            />
          </div>
        </div>
      </div>
    </v-card>
    <v-row>
      <v-col>
        <CropperModal ref="cropperModal" @croppedData="croppedData" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FloatBtn from "../employee-profile/FloatBtn.vue";
import CropperModal from "../../../core-module/components/CropperModal.vue";

import { createOrUpdateSubscriberProfile } from "../../methods/createOrUpdateSubscriberProfile";
import { saveUser } from "../../helpers/authHelper";

export default {
  components: {
    FloatBtn,
    CropperModal,
  },
  data() {
    return {
      savingData: false,
      companyProfile: null,
      avatar: "",
      isEdit: false,
      isEditable: true,
      logoUrl: null,
      hasLogo: false,
      reRender: 0,
    };
  },
  props: {
    companyData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    imgHeight: {
      type: String,
      default: "100",
    },
    imgWidth: {
      type: String,
      default: "100",
    },
  },
  watch: {
    companyData: {
      immediate: true,
      handler() {
        this.companyProfile = this.companyData ? this.companyData : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    resetFormData() {
      this.avatar = this.companyProfile?.user?.avatar;
      this.reRender++;
    },

    async onClick() {
      this.savingData = true;
      this.isEdit = false;

      if (this.avatar instanceof Blob) {
        let saveData = {
          user: {
            avatar: this.avatar,
          },
        };
        this.createOrUpdateProfile(saveData).then(response => {
          if (response.error) {
            this.$emit("onError");
            this.resetFormData();
          }
          if (response?.data) {
            this.companyProfile = response?.data;
            this.resetFormData();
            if (response?.data?.user) saveUser(response.data.user);
          }
          this.savingData = false;
        });
      }
    },
    createOrUpdateProfile(data) {
      return createOrUpdateSubscriberProfile(data);
    },
    setLogo(output) {
      this.hasLogo = true;
      var reader = new FileReader();
      reader.readAsDataURL(output);
      var self = this;

      reader.onloadend = function () {
        var base64data = reader.result;
        // self.categoryInput.url = base64data;
        self.logoUrl = base64data;
        self.$refs.cropperModal.show(self.logoUrl);
      };
      this.avatar = output;
    },
    croppedData(blobData, base64Data) {
      this.avatar = blobData;
      this.logoUrl = base64Data;
    },
  },
};
</script>
<style>
#fileInput {
  display: none;
}

#logo {
  display: none;
}
</style>
<style scoped>
.image-custom-preview {
  border-radius: 10px;
}
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
